<template>
  <div id="settings">


    <header class="inner-head border-transparent h-16">
      <div class="flex justify-between">
        <h2 class="sub-head-title">Assessment Grading</h2>
      </div>

    </header>


    <div class="w-full h-12 ml-8">
        <p>
          Setup and alter the default Assessment Grade heading titles. This will alter the display only for all areas within the platform where these titles are shown.

        </p>
      </div>


    <div class="assessmentconfig w-11/12  ml-4 flex pb-24">

      <div class="bg-white w-full mb-10 ">

        <div class="px-4">

        <form
          v-on:submit.prevent="saveSettingsGrades()"
          id="form-grades"
          ref="formGrades"
        >

        <table class="w-full">
              <thead class="bg-gray-100">
                <tr>
                  <th class="p-2 w-2/12" align="left">Order</th>
                  <th  class="text-left pl-4 w-2/12">Item</th>
                  <th class="w-6/12">Replaced Grade Title</th>
                  <th class="center w-2/12">In Use</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in gradesConfig.values"
                  :key="index"
                  class="course list-complete-item h-16 even:bg-gray-200"
                >
                  <td class="center pl-4 w-2/12">{{ index + 1 }}</td>
                  <td class="w-2/12">{{ item.title }}</td>
                  <td class="w-6/12">
                    <input
                      v-model="item.value"
                      type="text"
                    />
                  </td>
                  <td align="center" class="w-2/12">
                    <div class="checkbox" v-if="item.protect != true">
                      <input
                        :id="'chkUsed_' + index"
                        :name="'chkUsed_' + index"
                        v-model="item.used"
                        type="checkbox"
                        checked=""
                        v-bind:class="{ active: item.used == true }"
                      />
                      <label class="pb-4" :for="'chkUsed_' + index"></label>
                    </div>
                    <i class="icon fas fa-square" v-else />
                  </td>

                </tr>
              </tbody>
              </table>
        </form>

     

        <div class="w-full flex justify-end content-baseline space-x-10 text-right border-t">
          <div class="w-9/12 flex justify-end">

            <p v-if="hasCompleted" class="text-green-500 mt-4">
              Settings configuration saved.
            </p>
               
            <p v-if="errored" class="text-red-500 mt-4">
              We are not able to retrieve this information at the moment, please try
              back later.
            </p>

            <div
              style="text-align: center"
              class=""
              v-if="loading"
            >
              <i class="spinner fa fa-spinner fa-spin text-sm"></i>
              <p>Saving</p>
            </div>
          </div>
         <button
              @click="submitForm()"
              type="button"
              class="publish-button hover:opacity-75 mt-4"
            >
              Publish Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { settingsMixin } from "@/mixins/settingsMixin.js";

export default {
  name: "assessmentconfig",
  mixins: [settingsMixin],
  computed: {
    ...mapGetters({ currentUser: "currentUser", access: "currentAccess" }),
   
  },
  watch: {
  },
  data() {
    return {
   
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    changeViewParamType() {},
    submitForm() {
   
      if (this.$refs.formGrades.requestSubmit === undefined) {
        this.saveSettingsGrades();
      } else {
        this.$refs.formGrades.requestSubmit();
      }

    },
  },
  components: {
  },
};
</script>


<style scoped>
.list-complete-item td input[type="checkbox"] + label {
  padding-left: 0em !important;
}

.list-complete-item td .fa-square {
  font-size: 180% !important;
  padding-left: 0.5em;
}

</style>

